// src/CreateGroup.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserBadge from './UserBadge';
import './style-new.css';

import {
  FaHome,
  FaPlus,
  FaFolderOpen,
  FaFutbol,
  FaTrash,
  FaSignOutAlt,
} from "react-icons/fa";

import { MdCancel } from 'react-icons/md';

const CreateGroup = () => {
  const [groupName, setGroupName] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [createdGroupId, setCreatedGroupId] = useState(null);
  const navigate = useNavigate();

  const handleCreateGroup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setCreatedGroupId(null);

    try {
      const token = localStorage.getItem('authToken');

      const response = await fetch('/api/groups', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ name: groupName }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(`Group "${data.group.name}" created successfully!`);
        setCreatedGroupId(data.group.id);
        setGroupName('');
      } else {
        setMessage(data.message || 'Failed to create group.');
      }
    } catch (error) {
      console.error('Error creating group:', error);
      setMessage('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleViewGroup = () => {
    if (createdGroupId) {
      navigate(`/group/${createdGroupId}`);
    }
  };

  return (
    <div className="page-container">
      <UserBadge />
      <h2 className="section-heading">Create a New Group</h2>

      <form onSubmit={handleCreateGroup} style={{ marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="Group name"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          required
          style={{ padding: '8px', marginRight: '10px' }}
        />
        <div className="button-group" style={{ marginTop: '10px' }}>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary"
            style={{ marginRight: '10px' }}
          >
            <FaPlus />
            {loading ? 'Creating...' : 'Create Group'}
          </button>
          <button
            type="button"
            onClick={() => navigate('/groups')}
            className="btn pastel-red"
          >
            <MdCancel />
            Cancel
          </button>
        </div>
      </form>

      {message && <p>{message}</p>}

      {createdGroupId && (
        <button
          onClick={handleViewGroup}
          className="btn btn-primary"
          style={{ marginTop: '10px' }}
        >
          View Group
        </button>
      )}
    </div>
  );
};

export default CreateGroup;
